// DocketOpen Component
// This component manages multiple dockets, allowing users to open, view, and interact with dockets in different areas (A-F).
// It provides a search functionality to open dockets by number and displays an interface to switch between different docket areas.

import { useState, useRef, useEffect } from "react";
import { GrAdd } from "react-icons/gr";
import { ImSearch } from "react-icons/im";
import Main from "../../docket/Main";
import regx from "../../../functions/regx";
import './docketOpen.css';
import SearchPopup from "../SearchPopup/SearchPopup";


const DocketOpen = ({ num, setNum }) => {
    // Default data structure for a docket
    const dataOfDocket = { 'user': '', 'date': '', 'status': '', 'name': '', names: {}, flights: {}, accounts: [], num: 0, aufaFlights: {} };
    const [showSearchPopup, setShowSearchPopup] = useState(false);

    // State to manage multiple dockets (A-F)
    const [dockets, setDockets] = useState(
        {
            A: { data: dataOfDocket, open: false },
            B: { data: dataOfDocket, open: false },
            C: { data: dataOfDocket, open: false },
            D: { data: dataOfDocket, open: false },
            E: { data: dataOfDocket, open: false },
            F: { data: dataOfDocket, open: false }
        }
    );

    // State to manage the input for docket number
    const [numDocket, setNumDocket] = useState('');

    // State to keep track of the currently selected docket area
    const [area, setArea] = useState('A');

    // Ref for the input field to manage focus
    const inputRefFocos = useRef(null);

    // Function to focus on the input field
    const focosMy = () => {
        inputRefFocos.current.focus();
    }

    // Function to handle docket opening when Enter key is pressed 
    const getDocket = (e) => {
        if (e.key === 'Enter' && regx('number', numDocket) && numDocket.length === 6) {
            setDockets({ ...dockets, [area]: { data: { ...dataOfDocket, num: numDocket }, open: true } });
            setNumDocket('');
        }
    }

    // Function to handle input change for docket number
    const insertNum = (e) => {
        if (regx('number', e) && e.length < 7) {
            setNumDocket(e);
        }
    }

    // Effect to handle opening a docket from a list of dockets
    useEffect(() => {
        // Opening a docket from a list of dockets.
        num && setDockets({ ...dockets, [area]: { data: { ...dataOfDocket, num: num }, open: true } });
        setNum(0)
    }, [num])

    return (<>
        {/* Docket selection and search interface */}
        <div className="docket-open-bootom" onClick={focosMy}>
            {/* Render docket area buttons */}
            {Object.keys(dockets).map((value, key) =>
                <div key={key}
                    style={{
                        'order': key < 3 ? '-1' : '1',
                        backgroundColor: value === area ? '#47b5ff' : '#b5defc'
                    }}
                    onClick={() => setArea(value)}
                >
                    <p> {value} </p>
                    <p> {dockets[value]['data']['num'] || ''} </p>
                </div>
            )
            }
            {/* Docket search input */}
            <div className="docket-open-bootom-continer">
                <ImSearch className="docket-open-bootom-icon" onClick={() => setShowSearchPopup(true)} />

                {showSearchPopup && (
                    <SearchPopup onClose={() => setShowSearchPopup(false)} setNumDocket={setNum}/>
                )}



                <input
                    placeholder="מס' דוקט"
                    value={numDocket}
                    onChange={(e) => insertNum(e.target.value)}
                    onKeyDown={(e) => getDocket(e)}
                    ref={inputRefFocos}
                />
                <GrAdd className="docket-open-bootom-icon" onClick={() => { setDockets({ ...dockets, [area]: { data: dataOfDocket, open: true } }) }} />
            </div>
        </div>

        {/* Render the Main component when a docket is open */}
        {
            dockets[area]['open'] &&
            <Main
                num={dockets[area]['data']['num']}
                dataDocket={dockets[area]['data']}
                setDataDocket={(data) => setDockets({ ...dockets, [area]: { data: data, open: true } })}
                setClose={() => setDockets({ ...dockets, [area]: { data: dataOfDocket, open: false } })}
            />
        }
    </>)
}

export default DocketOpen;